import styled from '@emotion/styled';

import Image from 'components/global/Image';

export const Hr = styled.hr`
	width: 100%;
	border: 0.1px solid var(--border-color);
	padding: unset;
	margin: unset;
`;

export const ChartContainer = styled.div`
	width: 100%;
	position: relative;
	padding: var(--padding-4) 0;
	display: flex;
	flex-direction: row;
`;

export const ProgressBarContainer = styled.div`
	width: 100%;
`;

export const TopContainer = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	> span:first-of-type {
		&:hover {
			cursor: ${({ isClickable }) => (isClickable ? 'pointer' : 'default')};
			text-decoration: ${({ isClickable }) => (isClickable ? 'underline' : 'unset')};
		}
	}
`;

export const ChartBackground = styled.div`
	position: relative;
	height: 0.5rem;
	background-color: #ebebeb;
	border-radius: var(--small-border-radius);
`;

export const LogoSkeleton = styled.div`
	width: 5rem;
	height: 5rem;
	object-fit: contain;
	margin-right: var(--margin-4);
	body[dir='rtl'] & {
		margin-right: unset;
		margin-left: var(--margin-4);
	}
`;

export const Logo = styled(Image)`
	border-radius: 4px;
	object-fit: contain;
	position: absolute;
	top: 0;
	cursor: pointer;
	transition: 50ms;
	&:hover {
		opacity: 0.8;
		scale: 1.05;
	}
`;

export const LogoContainer = styled.div`
	min-width: 5rem;
	position: relative;
	height: 3.5rem;
`;
